module.exports = __webpack_public_path__ + "static/media/EngagingTechIcons.8279baf9.ttf";